import {useDownloadExcel} from "react-export-table-to-excel";
import React, {ReactNode, useRef, useState} from 'react';
import ExportIcon from "../../modules/icons/export";
import {SimpleTable} from "../../modals/types/table";
import "./table.scss"
import Pagination from "../pagination/pagination";

const Table = ({headers, bodies, title, headerContent, rowEachPage}: SimpleTable) => {
    const tableRef = useRef(null);
    const [currentItems, setCurrentItems] = useState<ReactNode[][] | []>([])
    const {onDownload} = useDownloadExcel({
        currentTableRef: tableRef.current,
        filename: "Campaigns Data",
        sheet: "Data"
    });
    return (
        <div className="Table">
            {headerContent}
            {
                title !== "" ?
                    <p className="Table-Title py-2">{title}</p>
                    :
                    null
            }
            <div className="table-responsive table-responsive-lg bg-transparent">
                <table ref={tableRef} className="table table-hover bg-transparent">
                    <tbody>
                    <tr>
                        {
                            headers.map((header, index) => {
                                return (
                                    <th key={index}>{header}</th>
                                )
                            })
                        }
                    </tr>
                    {
                        currentItems.map((body, index) => {
                            return (
                                <tr key={index}>
                                    {
                                        body.map((item, index2) => {
                                            return (
                                                <td key={index2}>{item}</td>
                                            )
                                        })
                                    }
                                </tr>
                            )
                        })
                    }
                    </tbody>
                </table>
            </div>
            <div className="w-100 d-flex flex-wrap gap-4 justify-content-between align-items-center mt-3">
                <Pagination items={bodies} setCurrentItems={setCurrentItems}
                            itemsPerPage={rowEachPage ? rowEachPage : 5}/>
                <button className="Export-Button" onClick={onDownload}>
                    <ExportIcon/>
                    &nbsp;&nbsp;
                    دانلود خروجی جدول
                </button>
            </div>
        </div>
    )
}

export default Table